<script lang="ts" setup>
import type {Component} from 'vue';
import {resolveComponent} from 'vue';
import type {Media} from '~~/types/strapi-blog';

type Block = { __typename: string; id: string | number } & Record<string, unknown>

defineProps<{ blocks?: Block[] }>();

const TextImage = resolveComponent('BlogComponentTextImage') as Component;
const ImageBanner = resolveComponent('BlogComponentImageBanner') as Component;
const CardColumns = resolveComponent('BlogComponentCardColumns') as Component;
const IntroSection = resolveComponent('BlogComponentIntroSection') as Component;
const TextVideo = resolveComponent('BlogComponentTextVideo') as Component;

const COMPONENT_MAP: Record<string, Component> = {
    ComponentLayoutTextImage: TextImage,
    ComponentLayoutImageBanner: ImageBanner,
    ComponentLayoutCardColumns: CardColumns,
    ComponentLayoutIntroSection: IntroSection,
    ComponentLayoutTextVideo: TextVideo,
};
</script>

<template>
    <div v-if="blocks?.length">
        <component
            :is="COMPONENT_MAP[block.__typename]"
            v-for="block in blocks"
            :key="block.id"
            v-bind="block"
        />
    </div>
</template>
